module.exports = __webpack_public_path__ + "static/media/icon-toast.86c89dd4.svg";